type getFetchConfigProps = {
  httpVerb?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: Record<string, any>;
  bearer?: string;
  contentType?: string;
  disableNextCache?: boolean;
};
export class ApiUtils {
  static getHeaders = (contentType = "text/plain", bearer: string) => {
    const headers: Record<string, any> = {
      "Content-Type": contentType,
    };

    if (bearer) {
      headers.authorization = `Bearer ${bearer}`;
    }

    return headers;
  };

  static getFetchConfig = ({
    contentType = "text/plain",
    httpVerb = "GET",
    bearer,
    body,
    disableNextCache,
  }: getFetchConfigProps) => {
    const object: Record<string, any> = {
      method: httpVerb,
      headers: this.getHeaders(contentType, bearer),
    };

    if (disableNextCache) {
      object.cache = "no-store";
    }

    if (body) {
      object.body = JSON.stringify(body);
    }

    // console.log("object to send", object);

    return object;
  };
}

// let tokenEncoded = bearer;
//     let session;
//     if (!tokenEncoded) {
//       if (typeof window === "undefined") {
//         session = await auth();
//       } else {
//         session = useGetSession();
//       }

//       if (session) {
//         tokenEncoded = await encode({
//           secret: process.env.NEXTAUTH_SECRET,
//           token: session.token,
//         });
//       }
//     }
